enum HTMLInputElementSelectionModeEnum {
	preserve = 'preserve',
	select = 'select',
	start = 'start',
	end = 'end'
}
export default HTMLInputElementSelectionModeEnum;
